import React, { useState } from 'react';
import { DocumentTypes } from '.';
import Button from '../../../../components/UI/Button';
import Checkbox from '../../../../components/UI/Checkbox';
import Accordion, { AccordionItem } from '../UI/Accordion';
import HorizontalDivider from '../UI/HorizontalDivider';
import SubheadingWithDivider from '../UI/SubheadingWithDivider';

import css from './PreTerms.module.scss';

interface PreTermsDocsProps {
  docs: Map<string, string> | undefined;
  acceptPreApprovalDocs: any;
}

export default function PreTermsDocs({
  docs,
  acceptPreApprovalDocs
}: PreTermsDocsProps) {
  const accordionItems: AccordionItem[] = [
    {
      label: 'Summary of Credit Terms',
      content: (
        <iframe
          height="600px"
          width="100%"
          src={`${docs?.get(DocumentTypes.CreditTerms)}#toolbar=0`}
        />
      )
    },
    {
      label: 'Privacy Policy',
      content: (
        <iframe
          height="600px"
          width="100%"
          src={`${docs?.get(DocumentTypes.PrivacyPolicy)}#toolbar=0`}
        />
      )
    },
    {
      label: 'Rewards Program Terms & Conditions',
      content: (
        <iframe
          height="600px"
          width="100%"
          src={`${docs?.get(DocumentTypes.RewardTerms)}#toolbar=0`}
        />
      )
    }
  ];

  const [read, setRead] = useState<boolean>(false);

  return (
    <>
      <SubheadingWithDivider />
      <h1>Cardmember terms & conditions</h1>
      <p className={css.pleaseRead}>
        <h5>IMPORTANT</h5>{' '}
        <span className={css.bold}>
          Please read the following terms before applying for Family Cash Card.
        </span>{' '}
        You apply, and agree you have read and will comply with these terms and
        conditions, when you select "Submit."
      </p>
      <HorizontalDivider />
      <Accordion items={accordionItems} />
      <div className={css.checkboxContainer}>
        <Checkbox
          id="read-terms"
          checked={read}
          onChange={() => {
            setRead(!read);
          }}
          label={
            <p className={css.checkboxLabel}>
              I have read and agree to the above terms and conditions
            </p>
          }
        />
      </div>
      <Button
        text="I agree"
        onClick={() => acceptPreApprovalDocs()}
        disabled={!read}
      />
      <p className={css.footerText}>
        By submitting this application, you agree to allow First National Bank
        of Omaha (FNBO®) to review your credit history.
      </p>
    </>
  );
}
